module.exports = __webpack_public_path__ + "img/firma_contrato_booker.c54617d4.png";